/*
 * IMPORTS
 */
import 'react-date-range/dist/styles.css' // Npm: React date range.
import 'react-date-range/dist/theme/default.css' // Npm: React date range.
import React from 'react' // Npm: react.js library.
import { useQuery } from '@apollo/client' // Npm: Apollo client.
import { HiChatBubbleLeftEllipsis } from 'react-icons/hi2' // Npm: React icons.
import { Flex, Spinner, Text } from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * PACKAGES
 */
import DateRangePicker from 'components/DateRangePicker'


/*
 * GRAPHS
 */
import SmsCountSentQuery from './__query__/index.sms.countSent.query'


/*
 * OBJECTS
 */
const Index = () => {
  // Hook assignment.
  const [dateRange, setDateRange] = React.useState({
    'selection': {
      'startDate': Object.DateRangeProvider()?.startDate,
      'endDate': Object.DateRangeProvider()?.endDate,
      'key': 'selection'
    }
  })
  const _QuerySmsCountSent = useQuery(SmsCountSentQuery, {
    'variables': {
      'startDate': dateRange?.selection.startDate,
      'endDate': dateRange?.selection.endDate
    },
    'fetchPolicy': Object.React.App.fetchPolicy,
    'pollInterval': Object.React.App.pollInterval
  })
  const _QuerySmsCountSentPerMonth = useQuery(SmsCountSentQuery, {
    'variables': {
      'startDate': Object.DateRangeProviderMonth()?.startDate,
      'endDate': Object.DateRangeProviderMonth()?.endDate
    },
    'fetchPolicy': Object.React.App.fetchPolicy,
    'pollInterval': Object.React.App.longPollInterval
  })

  // Return component.
  return (
    <Flex
      my='auto'
      w={{ 'base': '98%', 'md': '100%', 'lg': '100%' }}
      borderRadius='20px'
      bg='white'
      h='140px'
      p='15px'
      gap='12px'
      flexDir='column'
      color='#1B2559'
      fontSize={['clamp(13px, 1.5vw, 16px)']}
      justify='space-between'
      boxShadow='14px 17px 40px 4px rgba(112, 144, 176, 0.17)'>
      <DateRangePicker
        startDate={dateRange?.selection?.startDate}
        endDate={dateRange?.selection?.endDate}
        w='100%'
        fontSize='13px'
        height='max-content'
        gap='6px'
        setSelectDate={setDateRange}
        type='masterview'
        isLoading={_QuerySmsCountSent?.loading} />
      {_QuerySmsCountSent?.loading ? (
        <Spinner mx='auto' my='auto' color='#c1a9f4' />
      ) : (
        <>
          <Flex w='100%' justify='space-between'>
            <Flex
              my='auto'
              display='flex'
              flexDir='column'>
              <Text
                lineHeight='100%'
                color='gray.500'
                fontWeight='600'
                fontSize='13px'
                mb='8px'>
                Sms Sent
              </Text>
              <Text
                fontSize={['clamp(15px, 2vw, 25px)']}
                fontWeight='900'
                color='#1B2559'>
                {`${('COUNT_SUCCESSFUL' === _QuerySmsCountSent?.data?.SmsCountSent?.status ? _QuerySmsCountSent?.data?.SmsCountSent?.count : 0)}`}
              </Text>
              <Flex fontWeight='500' align='center'>
                <Text
                  color='green.500'
                  fontSize='12px'
                  fontWeight='700'
                  me='5px'>
                  {`${('COUNT_SUCCESSFUL' === _QuerySmsCountSentPerMonth?.data?.SmsCountSent?.status ? _QuerySmsCountSentPerMonth?.data?.SmsCountSent?.count : 0)
                    }`}
                </Text>
                <Text
                  color='secondaryGray.600'
                  fontSize='11px'
                  fontWeight='600'>
                  till today
                </Text>
              </Flex>
            </Flex>
            <Flex
              w='60px'
              h='60px'
              bg='#F1F5FF'
              borderRadius='10px'
              align='center'
              justify='center'>
              <HiChatBubbleLeftEllipsis color='#4308FF' size={25} />
            </Flex>
          </Flex>
        </>
      )}
    </Flex>
  )
}


/*
 * EXPORT
 */
export default Index
